import {API} from "@/Composables/api";

const getQuestions = async (params = {}) => {
    return API.get(route("admin.questions.index"), params);
};

const getQuestion = async (question) => {
    return API.get(route("admin.questions.show", question));
};

const storeQuestion = async (question, params = {}) => {
    return API.post(route("admin.questions.store"), params, question);
};

const updateQuestion = async (question, params = {}) => {
    return API.put(route("admin.questions.update", question.id), params, question);
};

const deleteQuestion = async (questionId: number, params = {}) => {
    return API.delete(route("admin.questions.destroy", questionId), params);
};

export {getQuestions, getQuestion, storeQuestion, updateQuestion, deleteQuestion};
